import api from "./api_client";

const employeeService = {
  getAll: async () => {
    const response = await api.get("/employees");
    return response.data;
  },

  getTeam: async () => {
    const response = await api.get("/employees/my-team");
    return response.data;
  },

  getManagers: async () => {
    const response = await api.get("/employees/managers");
    return response.data;
  },

  getHRResponsibles: async () => {
    const response = await api.get("/employees/hr-responsibles");
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/employees/${id}`);
    return response.data;
  },

  create: async (employeeData) => {
    const response = await api.post("/employees", employeeData);
    return response.data;
  },

  update: async (id, employeeData) => {
    const response = await api.put(`/employees/${id}`, employeeData);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/employees/${id}`);
    return response.data;
  },
};

export default employeeService;
